import { Campaign } from '../types/campaign.types';

import { privateClient } from './api-client';

const CAMPAIGNS_CACHE_KEY = 'precifield.campaigns.cache';

export const sharedApi = {
  campaigns: async () => {
    const campaigns = await privateClient.get('campaigns/').json<Campaign[]>();

    // Cache campaigns in localStorage
    try {
      localStorage.setItem(CAMPAIGNS_CACHE_KEY, JSON.stringify(campaigns));
    } catch (error) {
      // Ignore localStorage errors
    }

    return campaigns.sort((a, b) => a.year - b.year);
  },
  cgu: async () => {
    const cgu = await privateClient.get('accounts/tutorial/').json<{
      file: string;
    }>();

    return cgu;
  },
};
